// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';

@Component({
    selector: 'privacy-history-line-chart',
    standalone: false,
    template: `
        <div class="history-line-chart-container">
            <mon-chart-line [height]="250"
                        [data]="data"
                        [labels]="labels"
                        [series]="series"
                        [colors]="colors"
                        [override]="override"
                        [options]="options">
            </mon-chart-line>
        </div>
    `,
})
export class PrivacyHistoryLineChartComponent implements OnInit {
    @Input() history: any;

    data: any;
    labels: any;
    series: any;
    colors: any;
    override: any;
    options: any;

    constructor (
        private translateService: TranslateService,
        private pipeService: PipeService,
    ) {}

    ngOnInit (): void {
        this.setupChart();
    }

    private setupChart (): void {
        this.options = {
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    fontSize: 11,
                    boxWidth: 10,
                },
            },
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-0',
                        type: 'linear',
                        position: 'left',
                        ticks: {
                            fontSize: 11,
                            min: 0,
                            beginAtZero: true,
                            suggestedMax: 5,
                            maxTicksLimit: 5,
                            callback: (value: any) => {
                                return this.pipeService.get('monNumber')(value, '0,0');
                            },
                        },
                        gridLines: {
                            drawBorder: false,
                        },
                        scaleLabel: {
                            display: true,
                            labelString: this.translateService.getString('Data Violations'),
                            fontSize: 11,
                        },
                    },
                    {
                        id: 'y-axis-1',
                        type: 'linear',
                        position: 'right',
                        ticks: {
                            fontSize: 11,
                            min: 0,
                            beginAtZero: true,
                            suggestedMax: 5,
                            maxTicksLimit: 5,
                            callback: (value: any) => {
                                return this.pipeService.get('monNumber')(value, '0,0');
                            },
                        },
                        gridLines: {
                            drawBorder: false,
                            display: false,
                        },
                        scaleLabel: {
                            display: true,
                            labelString: this.translateService.getString('Content'),
                            fontSize: 11,
                        },
                    },
                ],
                xAxes: [
                    {
                        id: 'x-axis-0',
                        type: 'time',
                        gridLines: {
                            offsetGridLines: true,
                            drawBorder: false,
                            display: false,
                        },
                        ticks: {
                            fontSize: 11,
                            maxTicksLimit: 30,
                        },
                        time: {
                            minUnit: 'day',
                            displayFormats: {
                                millisecond: 'MMM D',
                                second: 'MMM D',
                                minute: 'MMM D',
                                hour: 'MMM D',
                                day: 'MMM D',
                                week: 'MMM D',
                                month: 'MMM D',
                                quarter: 'MMM D',
                                year: 'MMM D',
                            },
                        },
                    },
                ],
            },
        };
        this.labels = [];
        this.colors = ['#da5c5b', '#ff9d4e', '#a9dad6'];
        this.series = [
            this.translateService.getString('Data violations'),
            this.translateService.getString('Content with violations'),
            this.translateService.getString('Scanned content'),
        ];
        this.data = [[], [], []];
        this.override = [
            {
                xAxisID: 'x-axis-0',
                yAxisID: 'y-axis-0',
                type: 'line',
                fill: false,
                lineTension: 0,
                radius: 0,
                borderWidth: 1,
                pointRadius: 3,
                pointHitRadius: 34,
            },
            {
                yAxisID: 'y-axis-1',
                xAxisID: 'x-axis-0',
                type: 'line',
                fill: true,
                lineTension: 0,
                radius: 0,
                borderWidth: 1,
                pointRadius: 3,
                borderDash: [5, 5],
                pointHitRadius: 34,
            },
            {
                yAxisID: 'y-axis-1',
                xAxisID: 'x-axis-0',
                type: 'line',
                fill: true,
                lineTension: 0,
                radius: 0,
                borderWidth: 1,
                pointRadius: 3,
                borderDash: [5, 5],
                pointHitRadius: 34,
            },
        ];
        this.history.forEach((entry: any) => {
            const entryTime = new Date(entry.date).getTime();
            this.labels.push(entryTime);
            this.data[0].push({
                x: entryTime,
                y: entry.data_protection_violations_count || 0,
            });
            this.data[1].push({
                x: entryTime,
                y: entry.data_protection_pages_with_violations_count || 0,
            });
            this.data[2].push({
                x: entryTime,
                y: (entry.documents_count || 0) + (entry.page_count || 0),
            });
        });
    }
}
